/** TRON ↔ EVM 整页跳转前写入 session，便于 reload 后恢复钱包上下文 */

const KEY = 'hieswap_chain_nav_v1'
const TTL_MS = 120000
export const TRON_CHAIN_ID = 95500

export function isTronChainPageUrl(search = '') {
  return String(search || '').includes('fromTron')
}

/** 构建 from 链整页地址：Tron 必须带 fromTron，EVM 不带；保留 utm_source 等营销参数 */
export function buildFromChainPageUrl(chainId, loc = typeof location !== 'undefined' ? location : null) {
  const base = String(loc?.pathname || '/')
  const hash = String(loc?.hash || '')
  const rawSearch = String(loc?.search || '')
  const wantTron = Number(chainId) === TRON_CHAIN_ID

  if (wantTron) {
    if (rawSearch.includes('fromTron')) return `${base}${rawSearch}${hash}`
    const join = rawSearch ? `${rawSearch}&fromTron` : '?fromTron'
    return `${base}${join}${hash}`
  }

  if (!rawSearch.includes('fromTron')) return `${base}${rawSearch}${hash}`

  const params = new URLSearchParams(rawSearch)
  params.delete('fromTron')
  const q = params.toString()
  const qs = q ? `?${q}` : ''
  return `${base}${qs}${hash}`
}

/** 仅当 EVM ↔ Tron 边界变化时需要整页刷新 */
export function shouldReloadForFromChainSwitch(prevChainId, nextChainId, search = '') {
  const wasTron = Number(prevChainId) === TRON_CHAIN_ID || isTronChainPageUrl(search)
  const willBeTron = Number(nextChainId) === TRON_CHAIN_ID
  return wasTron !== willBeTron
}

export function markChainNavigationPending(meta = {}) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ ...meta, at: Date.now() }))
  } catch (_e) {
    void _e
  }
}

export function consumeChainNavigationPending() {
  try {
    const raw = sessionStorage.getItem(KEY)
    sessionStorage.removeItem(KEY)
    if (!raw) return null
    const o = JSON.parse(raw)
    if (Date.now() - Number(o.at || 0) > TTL_MS) return null
    return o
  } catch (_e) {
    return null
  }
}
